import React from "react";

const CodeFail = (props: { message: string }) => {
  return (
    <div className="container-fluid">
      <div className="row row-qr mx-auto d-block">
        <h2>{props.message}</h2>
      </div>
    </div>
  );
};

export default CodeFail;
